import React from 'react'
import styled from 'styled-components'
import PropTypes from 'prop-types'
import { H, Button, Wrapper, ArrowLeftIcon } from '@farewill/ui'
import { COLOR, FONT, GTR, BORDER } from '@farewill/ui/tokens'

import { QUESTIONS, DEFAULT_ANSWERS } from './constants'

const StyledWrapper = styled(Wrapper)`
  box-shadow: ${BORDER.SHADOW.M};
`
const StyledScreenReaderWrapper = styled(Wrapper)`
  position: absolute;
  left: -99999px;
  height: 1px;
  width: 1px;
  overflow: hidden;
`

const StyledHeader = styled.div`
  font-weight: ${FONT.WEIGHT.BOLD};
  font-size: ${FONT.SIZE.XL};
  line-height: 1.25;
  color: ${COLOR.BLACK};
  margin-bottom: ${GTR.M};
`

const StyledButton = styled(Button.Plain)`
  color: ${COLOR.GREY.MEDIUM};
  margin-top: ${GTR.XS};
`

const Question = ({ questionIndex, hasWill, onAnswer, onBack }) => {
  let question = QUESTIONS[questionIndex]
  if (question instanceof Array) {
    question = hasWill ? question[0] : question[1]
  }

  return (
    <StyledWrapper
      container
      paddingFromM={['L']}
      background={COLOR.WHITE}
      borderRadius="S"
    >
      <H color={COLOR.GREY.DARK} context>
        Question {questionIndex + 1} of {QUESTIONS.length}
      </H>

      <StyledScreenReaderWrapper aria-live="polite">
        {!questionIndex ? null : question.question || question}
      </StyledScreenReaderWrapper>
      <StyledHeader>{question.question || question}</StyledHeader>

      {(question.answers || DEFAULT_ANSWERS).map((answer) => (
        <Wrapper margin={[0, 0, 'XS']} key={answer}>
          <Button.Bordered stretch onClick={() => onAnswer(answer)}>
            {answer}
          </Button.Bordered>
        </Wrapper>
      ))}

      {!!questionIndex && (
        <StyledButton
          icon={ArrowLeftIcon}
          iconOnLeft
          iconMargin="XS"
          onClick={onBack}
          flush
        >
          Back
        </StyledButton>
      )}
    </StyledWrapper>
  )
}

Question.propTypes = {
  questionIndex: PropTypes.number.isRequired,
  hasWill: PropTypes.bool.isRequired,
  onAnswer: PropTypes.func.isRequired,
  onBack: PropTypes.func.isRequired,
}

export default Question
